(() => {
  const selector = '.card-wrapper .price-item';
  const originalMarkup = new Map(
    [...document.querySelectorAll(selector)].map((price) => [price, price.innerHTML])
  );
  let authority = null;
  let unsubscribe = null;

  const restore = () => {
    originalMarkup.forEach((markup, price) => {
      if (price.isConnected && price.innerHTML !== markup) price.innerHTML = markup;
    });
  };

  const scheduleRestore = () => requestAnimationFrame(restore);
  const bindAuthority = () => {
    const nextAuthority = window.PolyPouchPurchasingAuthority;
    if (!nextAuthority || nextAuthority === authority) return;
    unsubscribe?.();
    authority = nextAuthority;
    unsubscribe = authority.subscribe(scheduleRestore);
  };
  const handlePageHide = () => {
    unsubscribe?.();
    unsubscribe = null;
    authority = null;
  };

  document.addEventListener('polypouch:purchasing-authority-ready', bindAuthority);
  window.addEventListener('pagehide', handlePageHide, { once: true });
  bindAuthority();
})();

(() => {
  const processedFirstTiers = new WeakSet();
  let selectionScheduled = false;

  const hideUndiscountedComparisonPrices = (firstTier) => {
    const toggleMatchingComparison = (currentSelector, comparisonSelector) => {
      const currentPrice = firstTier.querySelector(currentSelector);
      const comparisonPrice = firstTier.querySelector(comparisonSelector);
      if (!comparisonPrice) return;

      const currentText = currentPrice?.textContent.trim().replace(/\s+/g, '');
      const comparisonText = comparisonPrice.textContent.trim().replace(/\s+/g, '');
      comparisonPrice.hidden = Boolean(currentText && comparisonText && currentText === comparisonText);
    };

    toggleMatchingComparison('.item-regular_price .money', '.item-compare_price');
    toggleMatchingComparison('.total-regular_price .money', '.total-compare_price');
  };

  const selectLowestTier = () => {
    selectionScheduled = false;

    document.querySelectorAll('.hulkapps-volume-discount-tiers').forEach((tierGroup) => {
      const firstTier = tierGroup.querySelector('.offer-option-item:first-of-type');
      const firstRadio = firstTier?.querySelector('input[type="radio"][name="card_group"]');
      if (!firstRadio) return;

      hideUndiscountedComparisonPrices(firstTier);
      if (processedFirstTiers.has(firstRadio)) return;

      processedFirstTiers.add(firstRadio);
      tierGroup.dataset.lowestTierDefault = firstRadio.value;
      if (firstRadio.checked) return;

      const firstLabel = firstTier.querySelector(`label[for="${CSS.escape(firstRadio.id)}"]`);
      (firstLabel || firstRadio).click();
    });
  };

  const scheduleLowestTierSelection = () => {
    if (selectionScheduled) return;
    selectionScheduled = true;
    requestAnimationFrame(selectLowestTier);
  };

  const tierObserver = new MutationObserver(scheduleLowestTierSelection);
  tierObserver.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('pagehide', () => tierObserver.disconnect(), { once: true });
  scheduleLowestTierSelection();
})();
